import React, { Component } from "react";
import { Row, Col } from 'reactstrap';
import VideoListing from '../video-ui/VideoListing';
import RecordNewModelVideo from '../player-recorder/RecordNewModelVideo';
import SocialIconsHeader from '../social/SocialIconsHeader';
import Switch from "react-switch";
import { Bold } from "@githubprimer/octicons-react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ApiClient from "../../api/ApiClient";
import SelectSearch from 'react-select-search';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import PlayCircleFilledRoundedIcon from '@material-ui/icons/PlayCircleFilledRounded';
import "../../styles/vocab.css";
import { playerRecorderControlText } from '../../styles/playerRecorderStyles';
import { playerRecorderControls } from '../../styles/playerRecorderStyles';
import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import { disambiguateSASURL } from "../../utils/urlSAS";
import LinkRoundedIcon from '@material-ui/icons/LinkRounded';
import { invisibleModalStyle, modalStyles, loaderStyle } from '../../styles/modalStyles';
import { connect } from 'react-redux';
import { updateScore, populateStore, requestFailedModal } from '../../actions';

class VocabListContainer extends Component {
    constructor(props) {
        super(props);
        this.apiClient = new ApiClient();
        this.state = {
            userdata: null,
            userId: this.props.userId,
            userLevel: this.props.userLevel,
            email: this.props.loggedInUser,
            isLoggedIn: this.props.isLoggedIn,
            signedInGroupId: this.props.signedInGroupId,
            openRecordNewModal: false,
            unpackedVideoOptions: [],
            isSharedLink: false,
            searchText: "",
            searchPlaceholder: "Search for a vocabulary list"
        }
    }

    componentWillReceiveProps(props) {
        if (props.searchText || props.searchText === "") {
            this.setState({
                searchText: props.searchText
            });
        }
        this.setState({
            userLevel: props.userLevel,
            isLoggedIn: props.isLoggedIn,
            email: props.loggedInUser,
            userId: props.userId,
            signedInGroupId: props.signedInGroupId
        });
    }

    marginTop = {
        marginTop: "50px"
    }

    paddingLeft = {
        paddingLeft: "10px",
        paddingRight: "10px"
    }

    seedVideoBtn = {
        marginTop: "-10px"
    }

    generateSearchOptions = (data) => {
        const uniqueList = {};
        data.forEach((datum) => {
            const name = datum.listName;
            if (!uniqueList[name]) {
                const searchTerm = {
                    name: name,
                    value: name
                }
                uniqueList[name] = searchTerm;
            }
        });
        const resArr = Object.values(uniqueList);
        this.props.setDropdownState(resArr);
    }

    onAddVocabListVideo = () => {
        if (this.props) {
            // Notify of generation
        }
    }

    recordCallback = () => {
        this.setState({ openRecordNewModal: false });
    }

    toggleRecordNewPopup = (event) => {
        event.preventDefault();
        this.setState(prevState => ({
            openRecordNewModal: !prevState.openRecordNewModal
        }));
    }

    pullVocabListSearchOptions = async () => {
        await this.setState({ searchText: "" })
        this.apiClient.getJSON(this, "/vocabList/load-all-vocab-list-video-components", "")
            .then(res => {
                if (res && res.status) {
                    this.generateSearchOptions(res.data);
                }
                else if (res && res.httpServerError) {
                    // throw "Something Went Wrong"
                }
            })
    }

    infuseListOptions = (res) => {
        for (let i = 0; i < res.length; i++) {

            let listOrder = res[i].generatedList;

            let infusedList = []
            for (let ii = 0; ii < listOrder.length; ii++) {
                let targetUV = res[i].userVideos.find((uv) => {
                    return uv._id.toString() === listOrder[ii]._id
                });
                if (!targetUV) {
                    targetUV = res[i].seedVideos.find((uv) => {
                        return uv._id.toString() === listOrder[ii]._id
                    });
                }
                infusedList.push(targetUV)
            }
            res[i].infusedList = infusedList;
        }
    }

    initialLoad = async () => {
        // Add sharable extension into search
        let extension = window.location.href.split("/vocab-specific-list/");
        if (extension.length > 1) {
            let listName = extension[1];
            await this.setState({ searchText: listName, isSharedLink: true });
            this.handleInputChange(listName, true)
        }
        else {
            this.apiClient.getJSON(this, "/vocabList/load-specific-vocab-list-data", "")
                .then(async (res) => {
                    if (res && res.status) {
                        this.infuseListOptions(res.data);
                        await this.setState({ unpackedVideoOptions: res.data });
                    }
                    else if (res && res.httpServerError) {
                        // throw "Something Went Wrong"
                    }
                });
        }
    }


    getOptions = async (query) => {
        try {
            let loadOptions = null;
            const options = await new Promise((resolve, reject) => {
                loadOptions = setInterval(async () => {
                    try {
                        if (this.state.dropdownSelectOptions.length > 0) {
                            var self = this;
                            const filtered = self.state.dropdownSelectOptions.filter((select) => {
                                const result = (select.name.includes(query));
                                return result;
                            });
                            resolve(filtered)
                        }
                    }
                    catch (e) {
                        resolve([])
                    }
                }, 200)
            });
            clearInterval(loadOptions);
            this.setState({ sOptions: options })
            return options;
        }
        catch (e) {
            return []
        }
    }

    setDropdownState = (data) => {
        this.setState({ dropdownSelectOptions: data, searchVisible: true })
    }

    generateSearchOptions = (data) => {
        const uniqueList = {};
        data.forEach((datum) => {
            const name = datum.listName;
            if (!uniqueList[name]) {
                const searchTerm = {
                    name: name,
                    value: name,
                }
                uniqueList[name] = searchTerm;
                // Add user
                const searchTermUser = {
                    name: datum.listCreator.userName,
                    value: datum.listCreator._id.toString(),
                }
                uniqueList[datum.listCreator.userName] = searchTermUser;
            }
        });
        const resArr = Object.values(uniqueList);
        this.setDropdownState(resArr);
    }

    // TODO Dedup this nonsense as with root search

    pullVocabListSearchOptions = async () => {
        await this.setState({ searchText: "" })
        this.apiClient.getJSON(this, "/vocabList/load-all-vocab-list-references", "")
            .then(res => {
                if (res && res.status) {
                    // Populate video big list
                    this.generateSearchOptions(res.data);
                }
                else if (res && res.httpServerError) {
                    // throw "Something Went Wrong"
                }
            })
    }

    async componentDidMount() {
        this.pullVocabListSearchOptions();
        this.initialLoad();
    }

    performQuery = async (query) => {
        if (query.length > 1) {
            this.setState({ searchText: query });
            this.apiClient.getJSON(this, "/vocabList/load-specific-vocab-list-data", "?searchterm=" + query)
                .then(async (res) => {
                    if (res && res.status) {
                        // Populate vi
                        let matches = res.data.filter((video) => {

                            return (video.listName.includes(query) || video.listCreator._id.includes(query));
                        });
                        this.infuseListOptions(matches);
                        await this.setState({ unpackedVideoOptions: matches });
                    }
                    else if (res && res.httpServerError) {
                        // throw "Something Went Wrong"
                    }

                });
        }

    }

    handleInputChange = (selection, isPreload) => {
        if (this.state.dropdownSelectOptions || isPreload) {
            this.performQuery(selection)
        }
    }

    clearSearchResults = async () => {
        await this.setState({ searchText: "" });
        this.initialLoad()
        // setTimeout(() => {
        //     this.performQuery("");
        // },500)
    }

    navigateToRecord = async (extension) => {
        window.location.href = process.env.PUBLIC_URL + "/vocab-record?list=" + extension;
    }

    navigateToNewLink = async (extension) => {
        window.open(process.env.PUBLIC_URL + "/vocab-specific-list?list=" + extension, '_newtab');
    }

    toggleListMode = async (isYourListMode) => {
        if (isYourListMode) {
            await this.setState({ isYourListMode: true });
        }
        else {
            await this.setState({ isYourListMode: false });
        }
    }

    expandContract = (id, isVisible) => {
        const item = this.state.unpackedVideoOptions.find((it) => it._id.toString() === id);
        item.isExpanded = isVisible;
        this.setState({ unpackedVideoOptions: this.state.unpackedVideoOptions });
    }

    deleteList = (tid) => {
        this.apiClient.postJSON(this, "/vocabList/delete", {
            listId: tid
        })
            .then(async (res) => {
                if (res && res.status) {
                    if (res.status === 200) {
                        alert("List Deleted");
                        window.location.reload();
                    }
                    else if (res.status === 217) {
                        alert("Unable to find list");
                    }
                }
                else {
                    throw "Something Went Wrong With User Action"
                }
            });
    }

    render() {

        document.title = 'Vocab - The ASL Data Community';

        if (!this.props.userId) {
            return (
                <div>
                    <div style={loaderStyle}>
                        Please login to access this view.
                    </div>
                </div>
            )
        }


        let vocabListDisplay = null;
        var self = this;
        if (this.state.unpackedVideoOptions) {
            let filteredData = this.state.unpackedVideoOptions;
            if (this.state.isYourListMode) {
                filteredData = this.state.unpackedVideoOptions.filter((item) => {
                    return item.listCreator._id.toString() === self.props.userId
                });
            }
            vocabListDisplay = filteredData.map((item) => {

                let expandedVideosList = item.infusedList.map((video) => {

                    return (
                        <div style={{ display: "inline-block", background: "white", border: "1px solid #ccc" }}>
                            <div className="cntr" >
                                <video controls muted className="vocab-video"
                                    src={video.convertedUrl ?
                                        disambiguateSASURL(video.convertedUrl, process.env) : disambiguateSASURL(video.convertedUrl, process.env)
                                    } type="video/mp4">
                                </video>
                            </div>
                            <div className="cntr">{video.name}</div>
                        </div>
                    )
                });

                return (
                    <React.Fragment>
                        <div>
                        </div>
                        <div className="flx-row vocab-video-listing-row listing-row" style={{ background: item.isExpanded ? "rgb(239, 255, 239)" : "white" }}>
                            <div className="w-10">
                                {item.isExpanded &&
                                    <ExpandLessRoundedIcon onClick={() => this.expandContract(item._id.toString(), !item.isExpanded)} />
                                }
                                {!item.isExpanded &&
                                    <ExpandMoreRoundedIcon onClick={() => this.expandContract(item._id.toString(), !item.isExpanded)} />
                                }
                            </div>
                            <div className="w-35">{item.listName}</div>
                            <div className="w-10">{item.infusedList.length}</div>
                            <div className="w-10">{item.date.substring(0, 10)}</div>
                            <div className="w-20">{item.listCreator.userName}</div>
                            <div className="w-15" style={{ textAlign: "right", paddingRight: "10px" }}>
                                {/* {!this.state.isYourListMode && */}

                                {/* } */}
                                {this.state.isYourListMode &&
                                    <svg onClick={() => this.deleteList(item._id)} style={{ cursor: "pointer", marginTop: "-3px", marginRight: "20px" }} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 0.75C11.733 0.75 13.1492 2.10645 13.2449 3.81558L13.25 4H18.5C18.9142 4 19.25 4.33579 19.25 4.75C19.25 5.1297 18.9678 5.44349 18.6018 5.49315L18.5 5.5H17.704L16.4239 18.5192C16.2912 19.8683 15.1984 20.91 13.8626 20.9945L13.6871 21H6.31293C4.95734 21 3.81365 20.0145 3.59883 18.6934L3.57614 18.5192L2.295 5.5H1.5C1.1203 5.5 0.806509 5.21785 0.756847 4.85177L0.75 4.75C0.75 4.3703 1.03215 4.05651 1.39823 4.00685L1.5 4H6.75C6.75 2.20507 8.20507 0.75 10 0.75ZM16.197 5.5H3.802L5.06893 18.3724C5.12768 18.9696 5.60033 19.4343 6.18585 19.4936L6.31293 19.5H13.6871C14.2872 19.5 14.7959 19.0751 14.9123 18.4982L14.9311 18.3724L16.197 5.5ZM11.75 8.25C12.1297 8.25 12.4435 8.53215 12.4932 8.89823L12.5 9V16C12.5 16.4142 12.1642 16.75 11.75 16.75C11.3703 16.75 11.0565 16.4678 11.0068 16.1018L11 16V9C11 8.58579 11.3358 8.25 11.75 8.25ZM8.25 8.25C8.6297 8.25 8.94349 8.53215 8.99315 8.89823L9 9V16C9 16.4142 8.66421 16.75 8.25 16.75C7.8703 16.75 7.55651 16.4678 7.50685 16.1018L7.5 16V9C7.5 8.58579 7.83579 8.25 8.25 8.25ZM10 2.25C9.08183 2.25 8.32881 2.95711 8.2558 3.85647L8.25 4H11.75C11.75 3.0335 10.9665 2.25 10 2.25Z" fill="#6E6E6E" />
                                    </svg>
                                }

                                <PlayCircleFilledRoundedIcon onClick={() => this.navigateToRecord(item._id.toString())} style={{ ...playerRecorderControls, color: "#7A22D1" }} className="control" />
                                <LinkRoundedIcon onClick={() => this.navigateToNewLink(item.listName)} style={{ ...playerRecorderControls, color: "#7A22D1" }} className="control" />
                            </div>
                        </div>
                        {item.isExpanded &&
                            (<div className="vocab-video-grid">
                                {expandedVideosList}
                            </div>)
                        }
                    </React.Fragment>
                )
            })
        }
        return (
            <React.Fragment>
                <div className="wiki-top-fixed-back" style={{ height: !this.state.isSharedLink ? "150px" : "100px", zIndex: "-99" }}></div>
                <div className="no-header-route-top">
                    <div className="vocab-list-directory-header-box">
                        {!this.state.isSharedLink &&
                            <div className="vocab-header-col-0">
                                <div onClick={() => this.toggleListMode(false)} className="tab-list-v" style={{
                                    background: this.state.isYourListMode ? "transparent" : "white",
                                    color: this.state.isYourListMode ? "white" : "#212529"
                                }}>
                                    All Lists
                                </div>
                                <div onClick={() => this.toggleListMode(true)} className="tab-list-v" style={{
                                    background: !this.state.isYourListMode ? "transparent" : "white",
                                    color: !this.state.isYourListMode ? "white" : "#212529"
                                }}>
                                    My Lists
                                </div>
                            </div>
                        }
                        <div className="vocab-header-col-1">
                            {!this.state.isSharedLink && <div className="header-search">
                                <SelectSearch
                                    disabled={!this.state.searchVisible}
                                    placeholder={this.state.searchPlaceholder}
                                    // autocomplete="off"
                                    options={this.state.sOptions}
                                    // closeOnSelect={true}
                                    getOptions={this.getOptions}
                                    search
                                    onChange={this.handleInputChange}
                                    value={this.state.searchText}
                                >
                                </SelectSearch>
                                <svg className="search-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 11.7101 16.9276 13.2866 15.964 14.5483L20.7071 19.2929C21.0976 19.6834 21.0976 20.3166 20.7071 20.7071C20.3466 21.0676 19.7794 21.0953 19.3871 20.7903L19.2929 20.7071L14.5483 15.964C13.2866 16.9276 11.7101 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5ZM10 4.5C6.96243 4.5 4.5 6.96243 4.5 10C4.5 13.0376 6.96243 15.5 10 15.5C13.0376 15.5 15.5 13.0376 15.5 10C15.5 6.96243 13.0376 4.5 10 4.5Z" fill="#6E6E6E" />
                                </svg>
                                {this.state.searchText && <HighlightOffRoundedIcon onClick={this.clearSearchResults} className="clear-search-btn" />}

                            </div>
                            }
                        </div>
                        {!this.state.isSharedLink &&
                            <div className="vocab-header-col-2">
                                <svg style={{ cursor: "pointer" }} onClick={() => window.location.href = process.env.PUBLIC_URL + "/create-vocab-list"} width="128" height="64" viewBox="0 0 128 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d)">
                                        <rect x="10" y="5.5" width="108" height="43" rx="21.5" fill="#7A22D1" />
                                        <path d="M30.8982 22.0068L31 22C31.3797 22 31.6935 22.2822 31.7432 22.6482L31.75 22.75V26.25H35.25C35.6297 26.25 35.9435 26.5322 35.9932 26.8982L36 27C36 27.3797 35.7178 27.6935 35.3518 27.7432L35.25 27.75H31.75V31.25C31.75 31.6297 31.4678 31.9435 31.1018 31.9932L31 32C30.6203 32 30.3065 31.7178 30.2568 31.3518L30.25 31.25V27.75H26.75C26.3703 27.75 26.0565 27.4678 26.0068 27.1018L26 27C26 26.6203 26.2822 26.3065 26.6482 26.2568L26.75 26.25H30.25V22.75C30.25 22.3703 30.5322 22.0565 30.8982 22.0068L31 22L30.8982 22.0068Z" fill="white" />
                                        <path d="M56.7576 32.5H54.8533L49.8363 24.7803C49.7093 24.585 49.6043 24.3823 49.5213 24.1724H49.4774C49.5164 24.397 49.536 24.8779 49.536 25.6152V32.5H47.8514V21.9971H49.8802L54.7288 29.5337C54.9339 29.8462 55.0657 30.061 55.1243 30.1782H55.1536C55.1048 29.8999 55.0804 29.4287 55.0804 28.7646V21.9971H56.7576V32.5ZM65.2847 29.2114H60.1724C60.192 29.9048 60.4044 30.4395 60.8096 30.8154C61.2198 31.1914 61.7813 31.3794 62.4942 31.3794C63.295 31.3794 64.0298 31.1401 64.6988 30.6616V32.0312C64.0152 32.4609 63.1119 32.6758 61.9888 32.6758C60.8853 32.6758 60.0186 32.3364 59.3887 31.6577C58.7637 30.9741 58.4512 30.0146 58.4512 28.7793C58.4512 27.6123 58.7955 26.6626 59.4839 25.9302C60.1773 25.1929 61.0367 24.8242 62.0621 24.8242C63.0875 24.8242 63.8809 25.1538 64.4424 25.813C65.004 26.4722 65.2847 27.3877 65.2847 28.5596V29.2114ZM63.6441 28.0103C63.6392 27.3999 63.4952 26.9263 63.212 26.5894C62.9288 26.2476 62.5381 26.0767 62.0401 26.0767C61.5518 26.0767 61.1368 26.2549 60.795 26.6113C60.4581 26.9678 60.2505 27.4341 60.1724 28.0103H63.6441ZM76.7488 25L74.5369 32.5H72.7571L71.3948 27.417C71.3411 27.2217 71.3069 27.002 71.2923 26.7578H71.263C71.2532 26.9238 71.2093 27.1387 71.1312 27.4023L69.6517 32.5H67.9085L65.7039 25H67.4617L68.824 30.4053C68.868 30.5664 68.8973 30.7812 68.9119 31.0498H68.9632C68.9778 30.8447 69.0169 30.625 69.0804 30.3906L70.5965 25H72.1932L73.5408 30.4272C73.5848 30.5981 73.6165 30.813 73.636 31.0718H73.6873C73.6971 30.8911 73.7337 30.6763 73.7972 30.4272L75.1302 25H76.7488ZM87.6726 32.5H81.8572V21.9971H83.6004V31.0278H87.6726V32.5ZM89.6226 23.4253C89.3443 23.4253 89.105 23.335 88.9048 23.1543C88.7095 22.9736 88.6118 22.7441 88.6118 22.4658C88.6118 22.1875 88.7095 21.9556 88.9048 21.77C89.105 21.5845 89.3443 21.4917 89.6226 21.4917C89.9107 21.4917 90.1548 21.5845 90.355 21.77C90.5552 21.9556 90.6553 22.1875 90.6553 22.4658C90.6553 22.7295 90.5552 22.9565 90.355 23.147C90.1548 23.3325 89.9107 23.4253 89.6226 23.4253ZM90.4649 32.5H88.7656V25H90.4649V32.5ZM91.9827 32.2656V30.6909C92.6174 31.1743 93.3181 31.416 94.0847 31.416C95.1101 31.416 95.6228 31.1133 95.6228 30.5078C95.6228 30.3369 95.5789 30.1929 95.491 30.0757C95.4031 29.9536 95.2835 29.8462 95.1321 29.7534C94.9856 29.6606 94.8098 29.5776 94.6047 29.5044C94.4046 29.4312 94.1799 29.3481 93.9309 29.2554C93.6233 29.1333 93.345 29.0039 93.096 28.8672C92.8518 28.7305 92.6467 28.5767 92.4807 28.4058C92.3196 28.23 92.1975 28.0322 92.1145 27.8125C92.0315 27.5928 91.99 27.3364 91.99 27.0435C91.99 26.6821 92.0755 26.3647 92.2463 26.0913C92.4172 25.813 92.6467 25.5811 92.9348 25.3955C93.2229 25.2051 93.5501 25.0635 93.9163 24.9707C94.2825 24.873 94.6609 24.8242 95.0515 24.8242C95.7449 24.8242 96.365 24.9292 96.9119 25.1392V26.626C96.3845 26.2646 95.7791 26.084 95.0955 26.084C94.8806 26.084 94.6853 26.106 94.5095 26.1499C94.3386 26.1938 94.1922 26.2549 94.0701 26.333C93.948 26.4111 93.8528 26.5063 93.7844 26.6187C93.7161 26.7261 93.6819 26.8457 93.6819 26.9775C93.6819 27.1387 93.7161 27.2754 93.7844 27.3877C93.8528 27.5 93.9529 27.6001 94.0847 27.688C94.2214 27.771 94.3826 27.8491 94.5681 27.9224C94.7586 27.9907 94.9758 28.0664 95.22 28.1494C95.5422 28.2812 95.8303 28.4155 96.0842 28.5522C96.343 28.689 96.5628 28.8452 96.7434 29.021C96.9241 29.1919 97.0632 29.3921 97.1609 29.6216C97.2586 29.8462 97.3074 30.1147 97.3074 30.4272C97.3074 30.8081 97.2195 31.1401 97.0437 31.4233C96.8679 31.7065 96.6336 31.9409 96.3406 32.1265C96.0476 32.312 95.7083 32.4487 95.3225 32.5366C94.9417 32.6294 94.5388 32.6758 94.114 32.6758C93.2937 32.6758 92.5833 32.5391 91.9827 32.2656ZM102.641 32.4194C102.309 32.5854 101.872 32.6685 101.33 32.6685C99.875 32.6685 99.1475 31.9702 99.1475 30.5737V26.333H97.895V25H99.1475V23.2642L100.847 22.7808V25H102.641V26.333H100.847V30.083C100.847 30.5273 100.927 30.8447 101.088 31.0352C101.25 31.2256 101.518 31.3208 101.894 31.3208C102.182 31.3208 102.431 31.2378 102.641 31.0718V32.4194Z" fill="white" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_d" x="0" y="0.5" width="128" height="63" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                                            <feOffset dy="5" />
                                            <feGaussianBlur stdDeviation="5" />
                                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                                        </filter>
                                    </defs>
                                </svg>

                            </div>}
                    </div>

                    <div className="vocab-list-container">
                        <div className="flx-row  listing-row" style={{ marginBottom: "10px", fontWeight: "600" }}>
                            <div className="w-10"></div>
                            <div className="w-35">List Name</div>
                            <div className="w-10"># Words</div>
                            <div className="w-10">Date</div>
                            <div className="w-20">Created By</div>
                            <div className="w-15">
                            </div>
                        </div>
                        {vocabListDisplay.length > 0 && vocabListDisplay}
                        {vocabListDisplay.length == 0 && (
                            <div className="cntr" style={{ borderTop: "1px solid #ccc", paddingTop: "20px" }}>There are no results</div>
                        )}
                    </div>
                </div>
            </React.Fragment >
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateScore,
    populateStore,
    requestFailedModal,
    dispatch
});

const VocabList = connect(
    
    mapDispatchToProps
)(VocabListContainer);

export default VocabList;
